import React, { useContext, useState } from 'react';

import { format } from 'date-fns';
import { Formik } from 'formik';
import { useSelector, useDispatch } from 'react-redux';
import Select from 'react-select';
import { Form, FormGroup } from 'reactstrap';
import * as Yup from 'yup';

import { AppContext } from '../../../../context';

import Style from './ProfessionalDetails.module.css';

import { applyJob } from '../../../../redux/actions/aeJobs';
import { getProfile } from '../../../../redux/actions/aeMyProfile';

import { citiesOptions } from '../../../../cities';
import { Button, ErrorMsg } from '../../../atoms';
import InputNumber from '../../../atoms/Input/number';
import InputListInForm from '../../../atoms/InputListInForm';

import { isEmpty } from '../../../../utils/generic';
import { pushEventInLoggy } from '../../../../utils/loggy';

function ProfessionalDetails({ userDetails, setSection, setProfessional, list, work, education, resume, currentJob, fresher, professional, parsedData, fillViaResume }) {
  const { isMobile } = useContext(AppContext);
  const { job_details, my_profile } = useSelector(({ my_profile, job_details }) => ({ my_profile, job_details }));
  const [locationsSelect, setLocationsSelect] = useState(
    !isEmpty(professional?.arr)
      ? professional?.arr?.map((ele) => ({ label: ele?.city, value: ele?.city }))
      : job_details?.data?.data?.locations?.length === 1
        ? [{ label: job_details?.data?.data?.locations?.[0]?.city, value: job_details?.data?.data?.locations?.[0]?.city }]
        : ''
  );
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const locationPreferenceOptions = isEmpty(job_details?.data?.data?.locations) ? '' : job_details?.data?.data?.locations?.map((ele) => ({ label: ele?.city, value: ele?.city }));

  const validationSchema = Yup.object().shape({
    experience_in_years: fresher ? Yup.number() : Yup.number().required('Please enter valid experience in years.'),
    notice_period_in_days: fresher ? Yup.number() : Yup.number().required('Please enter valid notice period in days.'),
    current_fixed: Yup.number().required('Please enter valid Fixed salary.').min(0, 'Amount should be greater than or equal to 0'),
    expected_fixed: Yup.number().required('Please enter valid Fixed salary.').min(0, 'Amount should be greater than or equal to 0'),
    skills: Yup.array().of(Yup.string().required('Skills cannot be empty')).min(1, 'Skills cannot be empty').required('Skills cannot be empty'),
    current_location: Yup.object().required('Please select current location')
  });

  const duration_list = parsedData?.experience?.map((ele) => ele?.duration);
  const total_experience = isEmpty(duration_list)
    ? 0
    : (
        duration_list
          .map(Number)
          .filter((num) => !isNaN(num) && num !== null && num !== undefined)
          .reduce((a, b) => a + b, 0) / 12
      ).toFixed(2);

  // const handleUpdateProfile = (values, arr) => {
  //   let body;

  //   if (fresher) {
  //     body = {
  //       candidate: {
  //         resume_link: resumeLink,
  //         resume,
  //         expected_ctc: {
  //           esops: values?.expected_esops ? values?.expected_esops : 0,
  //           fixed: values?.expected_fixed,
  //           total: Number(values.expected_fixed || 0) + Number(values.expected_esops || 0) + Number(values.expected_variable || 0),
  //           variable: values?.expected_variable ? values?.expected_variable : 0
  //         },
  //         open_for_locations: arr,
  //         education_details: education?.education_details
  //       }
  //     };
  //   } else {
  //     body = {
  //       candidate: {
  //         resume_link: resumeLink,
  //         resume,
  //         notice_period_in_months: values?.months,
  //         current_ctc: {
  //           esops: values?.current_esops ? values?.current_esops : 0,
  //           fixed: values?.current_fixed,
  //           total: Number(values.current_fixed || 0) + Number(values.current_esops || 0) + Number(values.current_variable || 0),
  //           variable: values?.current_variable ? values?.current_variable : 0
  //         },
  //         expected_ctc: {
  //           esops: values?.expected_esops ? values?.expected_esops : 0,
  //           fixed: values?.expected_fixed,
  //           total: Number(values.expected_fixed || 0) + Number(values.expected_esops || 0) + Number(values.expected_variable || 0),
  //           variable: values?.expected_variable ? values?.expected_variable : 0
  //         },
  //         open_for_locations: arr,
  //         education_details: education?.education_details,
  //         experience_details: work?.experience_details,
  //         experience_in_years: parsedData?.totalYearsExperience,
  //         current_role: currentJob?.current_role,
  //         current_employer: currentJob?.current_employer
  //       }
  //     };
  //   }

  //   dispatch(updateProfile(body))
  //     .then(() => {
  //       dispatch(getProfile())
  //         .then(() => {
  //           // profile successfully fetched
  //         })
  //         .catch(() => {
  //           // profile fetch failed
  //         });
  //     })
  //     .catch(() => {
  //       // profile updation failed
  //     });

  //   // console.log('success', data);

  //   setSection({ value: 'Submit', id: 4 });
  // };

  const handleBtnSubmit = (values, arr) => {
    if (list) {
      setProfessional({ values, arr });
      setSection({ value: 'Assessment', id: 4 });
    } else {
      let body;

      if (fresher) {
        body = {
          application: {
            resume_id: resume?.id,
            expected_ctc: {
              esops: values?.expected_esops ? String(values?.expected_esops)?.trim() : 0,
              fixed: String(values?.expected_fixed)?.trim(),
              total:
                Number(String(values?.expected_fixed)?.trim() || 0) + Number(String(values?.expected_esops)?.trim() || 0) + Number(String(values?.expected_variable)?.trim() || 0),
              variable: values?.expected_variable ? String(values?.expected_variable)?.trim() : 0
            },
            open_for_locations: arr,
            education_details: education?.education_details,
            current_role: currentJob?.current_role,
            current_employer: currentJob?.current_employer,
            skills: values?.skills,
            current_location: { city: values.current_location?.value }
          }
        };
      } else {
        body = {
          application: {
            resume_id: resume?.id,
            notice_period_in_days: String(values?.notice_period_in_days)?.trim(),
            experience_in_years: String(values?.experience_in_years)?.trim(),
            current_ctc: {
              esops: values?.current_esops ? String(values?.current_esops)?.trim() : 0,
              fixed: String(values?.current_fixed)?.trim(),
              total:
                Number(String(values?.current_fixed)?.trim() || 0) + Number(String(values?.current_esops)?.trim() || 0) + Number(String(values?.current_variable)?.trim() || 0),
              variable: values?.current_variable ? String(values?.current_variable)?.trim() : 0
            },
            expected_ctc: {
              esops: values?.expected_esops ? String(values?.expected_esops)?.trim() : 0,
              fixed: String(values?.expected_fixed)?.trim(),
              total:
                Number(String(values?.expected_fixed)?.trim() || 0) + Number(String(values?.expected_esops)?.trim() || 0) + Number(String(values?.expected_variable)?.trim() || 0),
              variable: values?.expected_variable ? String(values?.expected_variable)?.trim() : 0
            },
            open_for_locations: arr,
            education_details: education?.education_details,
            experience_details: work?.experience_details,
            current_role: currentJob?.current_role,
            current_employer: currentJob?.current_employer,
            skills: values?.skills,
            current_location: { city: values.current_location?.value }
          }
        };
      }

      dispatch(applyJob(job_details?.data?.data?.id, body))
        .then(() => {
          pushEventInLoggy(
            {
              event: 'AEx_Application_Created',
              other_properties: {
                created_at: format(new Date(), 'yyyy-MM-dd, HH:mm:ss'),
                candidate_zoho_id: my_profile?.data?.data?.id,
                posting_title: job_details?.data?.data?.job_role_name,
                job_role_code: job_details?.data?.data?.role_code,
                first_name: my_profile?.data?.data?.first_name,
                last_name: my_profile?.data?.data?.last_name,
                mobile_number: my_profile?.data?.data?.mobile_number,
                email: my_profile?.data?.data?.email
              }
            },
            my_profile
          );

          // submit assessment
          // handleUpdateProfile(values, arr);

          dispatch(getProfile())
            .then(() => {
              // profile successfully fetched

              setIsSubmitting(false);
            })
            .catch(() => {
              // profile fetch failed

              setIsSubmitting(false);
            });
          setSection({ value: 'Submit', id: 4 });
        })
        .catch(() => {
          // application submission failed

          setIsSubmitting(false);
        });
    }
  };

  const handleBack = (values) => {
    let arr = findArrayForLocations();

    setProfessional({ values, arr });
    setSection({ value: 'Educational Details', id: 2 });
  };

  const inputStyles = {
    control: (base) => ({
      ...base,
      padding: '5px',
      color: '#3c4858',
      fontWeight: '400',
      border: '1px solid #aabfc3',
      display: 'flex',
      borderRadius: '5px',
      width: '100%',
      backgroundColor: '#FFFFFF',
      fontSize: '16px',
      lineHeight: '20px'
    }),
    menu: (base) => ({
      ...base,
      color: '#000000',
      fontSize: '16px',
      lineHeight: '20px',
      zIndex: '2000'
    })
  };

  const findArrayForLocations = () => {
    const arr = [];

    for (let i = 0; i < locationsSelect.length; i++) {
      arr.push({
        country: 'India',
        city: locationsSelect?.[i]?.value
      });
    }

    return arr;
  };

  return (
    <Formik
      enableReinitialize
      initialValues={{
        experience_in_years: fillViaResume
          ? total_experience
          : !isEmpty(professional?.values?.experience_in_years)
            ? professional?.values?.experience_in_years
            : userDetails?.experience_in_years || 0,
        notice_period_in_days:
          !isEmpty(professional?.values?.notice_period_in_days) && !isNaN(Number(professional?.values?.notice_period_in_days))
            ? professional?.values?.notice_period_in_days
            : !isNaN(Number(userDetails?.notice_period_in_days))
              ? userDetails?.notice_period_in_days
              : null,
        current_esops: !isEmpty(professional?.values?.current_esops) ? professional?.values?.current_esops : userDetails?.current_ctc?.esops || '',
        current_fixed: !isEmpty(professional?.values?.current_fixed) ? professional?.values?.current_fixed : userDetails?.current_ctc?.fixed || '',
        current_variable: !isEmpty(professional?.values?.current_variable) ? professional?.values?.current_variable : userDetails?.current_ctc?.variable || '',
        expected_esops: !isEmpty(professional?.values?.expected_esops) ? professional?.values?.expected_esops : userDetails?.expected_ctc?.esops || '',
        expected_fixed: !isEmpty(professional?.values?.expected_fixed) ? professional?.values?.expected_fixed : userDetails?.expected_ctc?.fixed || '',
        expected_variable: !isEmpty(professional?.values?.expected_variable) ? professional?.values?.expected_variable : userDetails?.expected_ctc?.variable || '',
        location: !isEmpty(professional?.arr) ? professional?.arr?.map((ele) => ({ label: ele?.city, value: ele?.city })) : userDetails?.open_for_locations || '',
        skills: fillViaResume
          ? !isEmpty(parsedData?.skills)
            ? parsedData?.skills
            : []
          : !isEmpty(professional?.values?.skills)
            ? professional?.values?.skills
            : userDetails?.skills || [],
        current_location: !isEmpty(userDetails?.current_location) ? { label: userDetails?.current_location?.city, value: userDetails?.current_location?.city } : ''
      }}
      onSubmit={(values) => {
        let arr = findArrayForLocations();

        setIsSubmitting(true);
        handleBtnSubmit(values, arr);
      }}
      validationSchema={validationSchema}
    >
      {({ values, handleBlur, handleChange, handleSubmit, setFieldValue, errors, touched }) => {
        const current_total = Number(values.current_fixed || 0) + Number(values.current_esops || 0) + Number(values.current_variable || 0);
        const expected_total = Number(values.expected_fixed || 0) + Number(values.expected_esops || 0) + Number(values.expected_variable || 0);

        return (
          <Form onSubmit={handleSubmit}>
            <div className={Style.BasicDetailsEdit}>
              {!isMobile ? <div className={`${Style.sectionHeading} padding32T`}>Professional Details & Preferences</div> : null}
              <FormGroup className='row margin-0'>
                <div className='col-12 padding0L padding0R'>
                  <label className={`${Style.smallHeading} ${Style.greyColor2} padding16T`} htmlFor='notice_period_in_days'>
                    Notice Period (in days)<span>{fresher ? '' : '*'}</span>
                  </label>
                  {fresher ? (
                    <input className={`${Style.inputBoxEditable} bg-dark-white-3`} data-testid='notice-period' disabled={true} value={0} />
                  ) : (
                    <InputNumber
                      className={Style.inputBoxEditable}
                      data-testid='notice-period'
                      id='notice_period_in_days'
                      name='notice_period_in_days'
                      onBlur={handleBlur('notice_period_in_days')}
                      onChange={handleChange('notice_period_in_days')}
                      value={values.notice_period_in_days}
                    />
                  )}
                </div>
                {errors.notice_period_in_days && touched.notice_period_in_days ? <ErrorMsg msg={errors.notice_period_in_days} /> : null}
              </FormGroup>
              <FormGroup className='row margin-0'>
                <div className='col-12 padding0L padding0R'>
                  <label className={`${Style.smallHeading} ${Style.greyColor2} padding16T`} htmlFor='experience_in_years'>
                    Total Experience (in years)<span>{fresher ? '' : '*'}</span>
                  </label>
                  {fresher ? (
                    <input className={`${Style.inputBoxEditable} bg-dark-white-3`} disabled={true} value={0} />
                  ) : (
                    <InputNumber
                      className={Style.inputBoxEditable}
                      data-testid='experience_in_years'
                      id='experience_in_years'
                      name='experience_in_years'
                      onBlur={handleBlur('experience_in_years')}
                      onChange={handleChange('experience_in_years')}
                      value={values.experience_in_years}
                    />
                  )}
                </div>
                {errors.experience_in_years && touched.experience_in_years ? <ErrorMsg msg={errors.experience_in_years} /> : null}
              </FormGroup>
              <FormGroup className='row margin-0'>
                <div className='col-12 padding0L padding0R'>
                  <label className={`${Style.smallHeading} ${Style.greyColor2} padding16T`} htmlFor='skills'>
                    Skills
                  </label>
                  <InputListInForm
                    fieldName='skills'
                    placeholder='Add Skills (comma-separated)'
                    setFieldValue={setFieldValue}
                    styleClass={Style.inputBoxEditable}
                    value={values.skills}
                  />
                  {errors.skills && touched.skills ? <ErrorMsg msg={errors.skills} /> : null}
                </div>
              </FormGroup>
              <FormGroup className='row margin-0'>
                <div className='col-12 padding0L padding0R'>
                  <label className={`${Style.smallHeading} ${Style.greyColor2} padding16T`} htmlFor='location'>
                    Location Preferences
                  </label>
                  {job_details?.data?.data?.locations?.length <= 1 ? (
                    <div className={`${Style.inputBoxEditable} bg-dark-white-3`} data-testid='location-preferences'>
                      {isEmpty(job_details?.data?.data?.locations) ? 'NA' : job_details?.data?.data?.locations?.[0]?.city}
                    </div>
                  ) : (
                    <Select
                      data-testid='location-preferences'
                      errors={errors.city}
                      id='city'
                      isMulti={true}
                      name='city'
                      onChange={setLocationsSelect}
                      options={locationPreferenceOptions}
                      placeholder='Select location'
                      styles={inputStyles}
                      value={locationsSelect}
                    />
                  )}
                  {errors.location && touched.location ? <ErrorMsg msg={errors.location} /> : null}
                </div>
              </FormGroup>
              <FormGroup className='row margin-0'>
                <div className='col-12 padding0L padding0R'>
                  <label className={`${Style.smallHeading} ${Style.greyColor2} padding16T`} htmlFor='location'>
                    Current Location
                  </label>
                  <Select
                    data-testid='current-location'
                    errors={errors.current_location}
                    id='current_location'
                    name='current_location'
                    onChange={(e) => setFieldValue('current_location', e)}
                    options={citiesOptions}
                    placeholder='Select location'
                    styles={inputStyles}
                    value={values.current_location}
                  />
                  {errors.current_location && touched.current_location ? <ErrorMsg msg={errors.current_location} /> : null}
                </div>
              </FormGroup>
              <FormGroup className='row margin-0'>
                <label className={`${Style.smallHeading} ${Style.greyColor2} padding16T `}>
                  Current Salary (Annual CTC LPA)<span>{fresher ? '' : '*'}</span>
                </label>
                <div className='col-12 padding0L padding0R'>
                  <div className={Style.InputGroup}>
                    <label htmlFor='current_fixed'>
                      Fixed <span>{fresher ? '' : '*'}</span>
                    </label>
                    {fresher ? (
                      <input className={`${Style.inputBoxEditable} bg-dark-white-3`} disabled={true} value='--' />
                    ) : (
                      <InputNumber
                        className={Style.inputBoxEditable}
                        data-testid='current_fixed'
                        id='current_fixed'
                        name='current_fixed'
                        onBlur={handleBlur('current_fixed')}
                        onChange={handleChange}
                        placeholder='Eg: 24.45 LPA'
                        value={values.current_fixed}
                      />
                    )}
                    {errors.current_fixed && touched.current_fixed ? <ErrorMsg msg={errors.current_fixed} /> : null}
                  </div>

                  <div className={Style.InputGroup}>
                    <label htmlFor='current_variable'>Variable</label>
                    {fresher ? (
                      <input className={`${Style.inputBoxEditable} bg-dark-white-3`} disabled={true} value='--' />
                    ) : (
                      <InputNumber
                        className={Style.inputBoxEditable}
                        id='current_variable'
                        name='current_variable'
                        onBlur={handleBlur('current_variable')}
                        onChange={handleChange}
                        placeholder='Eg: 24.45 LPA'
                        value={values.current_variable}
                      />
                    )}
                    {errors.current_variable && touched.current_variable ? <ErrorMsg msg={errors.current_variable} /> : null}
                  </div>

                  <div className={Style.InputGroup}>
                    <label htmlFor='current_esops'>ESOPs</label>
                    {fresher ? (
                      <input className={`${Style.inputBoxEditable} bg-dark-white-3`} disabled={true} value='--' />
                    ) : (
                      <InputNumber
                        className={Style.inputBoxEditable}
                        id='current_esops'
                        name='current_esops'
                        onBlur={handleBlur('current_esops')}
                        onChange={handleChange}
                        placeholder='Eg: 24.45 LPA'
                        value={values.current_esops}
                      />
                    )}
                    {errors.current_esops && touched.current_esops ? <ErrorMsg msg={errors.current_esops} /> : null}
                  </div>

                  <div className={Style.InputGroup}>
                    <label htmlFor='current_total'>
                      Total<span>{fresher ? '' : '*'}</span>
                    </label>
                    {fresher ? (
                      <input className={`${Style.inputBoxEditable} bg-dark-white-3`} disabled={true} value='--' />
                    ) : (
                      <InputNumber
                        className={Style.inputBoxEditable}
                        data-testid='current_total'
                        disabled
                        id='current_total'
                        name='current_total'
                        onBlur={handleBlur('current_total')}
                        onChange={handleChange}
                        placeholder='Total LPA'
                        value={current_total === 0 ? '' : current_total}
                      />
                    )}
                  </div>
                </div>
              </FormGroup>
              <FormGroup className='row margin-0'>
                <label className={`${Style.smallHeading} ${Style.greyColor2} padding16T `} htmlFor='expected_fixed'>
                  Expected Salary (Annual CTC)<span>*</span>
                </label>
                <div className='col-12 padding0L padding0R'>
                  <div className={Style.InputGroup}>
                    <label htmlFor='expected_fixed'>
                      Fixed <span>*</span>
                    </label>
                    <InputNumber
                      className={Style.inputBoxEditable}
                      data-testid='expected_fixed'
                      id='expected_fixed'
                      name='expected_fixed'
                      onBlur={handleBlur('expected_fixed')}
                      onChange={handleChange}
                      placeholder='Eg: 24.45 LPA'
                      value={values.expected_fixed}
                    />
                    {errors.expected_fixed && touched.expected_fixed ? <ErrorMsg msg={errors.expected_fixed} /> : null}
                  </div>

                  <div className={Style.InputGroup}>
                    <label htmlFor='current_variable'>Variable</label>
                    <InputNumber
                      className={Style.inputBoxEditable}
                      id='expected_variable'
                      name='expected_variable'
                      onBlur={handleBlur('expected_variable')}
                      onChange={handleChange}
                      placeholder='Eg: 24.45 LPA'
                      value={values.expected_variable}
                    />
                    {errors.expected_variable && touched.expected_variable ? <ErrorMsg msg={errors.expected_variable} /> : null}
                  </div>

                  <div className={Style.InputGroup}>
                    <label htmlFor='current_esops'>ESOPs</label>
                    <InputNumber
                      className={Style.inputBoxEditable}
                      id='expected_esops'
                      name='expected_esops'
                      onBlur={handleBlur('expected_esops')}
                      onChange={handleChange}
                      placeholder='Eg: 24.45 LPA'
                      value={values.expected_esops}
                    />
                    {errors.expected_esops && touched.expected_esops ? <ErrorMsg msg={errors.expected_esops} /> : null}
                  </div>

                  <div className={Style.InputGroup}>
                    <label htmlFor='expected_total'>
                      Total<span>*</span>
                    </label>
                    <InputNumber
                      className={Style.inputBoxEditable}
                      data-testid='expected_total'
                      disabled
                      id='expected_total'
                      name='expected_total'
                      onChange={handleChange}
                      placeholder='Total LPA'
                      value={expected_total === 0 ? '' : expected_total}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className={`${Style.bottomFixedBtns} flexStyleStart`}>
              <Button className='general-outline-style paddingTop flex-style-center align-items-center' onClick={() => handleBack(values)}>
                Back
              </Button>
              <Button className='general-style' data-testid='professional-details-next-button' disabled={isSubmitting} isSubmitting={isSubmitting} type='submit'>
                {list ? 'Next' : 'Submit'}
              </Button>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
}

export default ProfessionalDetails;
